<template>
  <span>
    <a-spin v-if="loading">
      <a-icon slot="indicator" type="loading" style="font-size: 1em; color: white" spin/>
    </a-spin>
    <span v-else>{{ count }}</span>
  </span>
</template>

<script>
import attachableApi from '~/api/attachable';

export default {
  name: "NoteCountComponent",
  props: {
    customerId: {
      type: [Number, String],
      default: null,
    },
    instance: {
      type: Object,
      default: null,
      validator: function (obj) {
        return ((typeof obj.id === 'number' || typeof obj.id === 'string') && typeof obj.class === 'string')
      }
    },
    categoryId: {
      type: [Number, String],
      default: null,
    }
  },
  data() {
    return {
      count: 0,
      context: null,
      childClass: 'App\\Models\\Note',
      loading: false,
    }
  },
  created() {
    this.setContext();
    this.getCountByContext();
  },
  methods: {
    setContext() {
      if (this.instance !== null) {
        this.context = 'instance';
      } else {
        this.context = 'family';
      }
    },
    getCountByContext() {
      this.loading = true;

      if (this.context === 'instance') {
        attachableApi.countByInstanceAndChildClass(
            this.instance,
            this.childClass
        ).then((response) => {
          this.count = response.data;
        }).finally(() => {
          this.loading = false
        })
      } else {
        attachableApi.countByFamilyCategoryAndChildClass(
            this.customerId,
            this.categoryId,
            this.childClass
        ).then((response) => {
          this.count = response.data;
        }).finally(() => {
          this.loading = false
        })
      }
    }
  }
}
</script>

<style scoped>

</style>